import { ChangeDetectionStrategy, Component, ElementRef, Input, Output, ViewChild, EventEmitter } from '@angular/core';

import {
  IAdditionalComponentsCatalogueCart,
  IAdditionalComponentsCatalogueProduct
} from '../../../enclosure/models/product-accessories.model';
import { AddAdditionalComponentsFromCatalogueModalComponent } from './add-additional-components-from-catalogue-modal/add-additional-components-from-catalogue-modal.component';
import { IProduct } from '../../../shared/models/product.model';
import { IBomModel } from '../../../prisma-xs/models/bom.model';
import { BomModelByReferencePipe } from '../../pipes/bom-model-by-reference.pipe';

declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-bom-add-additional-components-modal',
    templateUrl: './bom-add-additional-components-modal.html',
    styleUrl: './bom-add-additional-components-modal.scss',
    standalone: false
})
export class BomAddAdditionalComponentsModal {
  selectedGroupIndex = 0;
  productsGroups: IAdditionalComponentsCatalogueProduct[];

  addedProducts: IAdditionalComponentsCatalogueCart[] = [];
  adjustedExistingProducts: IBomModel[] = [];

  @ViewChild('bomAddAdditionalComponentsModal') bomAddAdditionalComponentsModalEl: ElementRef;
  // eslint-disable-next-line max-len
  @ViewChild('confirmationModal') confirmationModalEl: AddAdditionalComponentsFromCatalogueModalComponent;

  @Input() bomModelsAccessories: IBomModel[];

  @Input() set additionalComponentsCatalogue(value: IAdditionalComponentsCatalogueProduct[]) {
    if (!value) {
      return
    }
    this.productsGroups = value;
  };

  @Output() productsFromCart = new EventEmitter<IAdditionalComponentsCatalogueCart[]>();
  @Output() adjustedProductsFromCart = new EventEmitter<IBomModel[]>();

  openModal() {
    jQuery(this.bomAddAdditionalComponentsModalEl.nativeElement).modal('show');
  }

  closeModal() {
    this.addedProducts = [];
    this.adjustedExistingProducts = [];

    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.bomAddAdditionalComponentsModalEl.nativeElement).modal('hide');
  }

  selectGroup(index: number) {
    this.selectedGroupIndex = index;
  }

  private addNewProducts(quantity: number, product: IProduct) {
    const addedProduct = this.addedProducts?.find(addedProduct => addedProduct?.product?.reference === product.reference);
    if (addedProduct) {
      if (quantity === 0) {
        const index = this.addedProducts.indexOf(addedProduct);
        this.addedProducts.splice(index, 1);

        return;
      }
      addedProduct.quantity = quantity;

      return;
    }

    this.addedProducts.push({ product, quantity });
  }

  changeNumberOfProducts(numberOfProducts: number, product: IProduct) {
    this.addNewProducts(numberOfProducts, product);

    this.addedProducts = [].concat(this.addedProducts)
  }

  private adjustNumberOfExistingProducts(quantity: number, existingProductInBom: IBomModel) {
    const existingProduct = new BomModelByReferencePipe().transform(this.adjustedExistingProducts, existingProductInBom?.article?.ref);
    if (!existingProduct) {
      this.adjustedExistingProducts.push({ ...existingProductInBom, quantity });
      return;
    }

    const index = this.adjustedExistingProducts.indexOf(existingProduct);
    if (index !== -1) {
      this.adjustedExistingProducts.splice(index, 1);
    }

    if (quantity !== existingProductInBom?.quantity) {
      this.adjustedExistingProducts.push({ ...existingProductInBom, quantity });
    }
  }

  adjustNumberOfExistingProduct(numberOfProducts: number, existingProductInBom: IBomModel) {
    this.adjustNumberOfExistingProducts(numberOfProducts, existingProductInBom);

    this.adjustedExistingProducts = [].concat(this.adjustedExistingProducts);
  }

  returnToCatalogue() {
    jQuery(this.bomAddAdditionalComponentsModalEl.nativeElement).modal('show');
  }

  addProducts() {
    (document.activeElement as HTMLElement)?.blur();
    jQuery(this.bomAddAdditionalComponentsModalEl.nativeElement).modal('hide');
    this.confirmationModalEl.openModal();
  }

  confirmAddingProducts() {
    if (this.addedProducts.length) {
      this.productsFromCart.emit(this.addedProducts);
    }
    if (this.adjustedExistingProducts.length) {
      this.adjustedProductsFromCart.emit(this.adjustedExistingProducts)
    }
    this.closeModal();
  }
}
